<template>

    <div class="row">

        <div class="col pt-2">


            <!--  Page  -->
            <div v-if="user_permissions.includes('read-companies')" class="bg-white rounded py-2 shadow-widget border">

                <!-- Page header -->
                <div class="px-3">

                    <div class="d-flex">

                        <h4>{{ $t('page.companies') }}</h4>

                        <div class="ml-auto align-self-center">
                          <div v-b-tooltip.hover.right="{
                               title:!user_permissions.includes('create-companies')? $t('permission.permission_denied', { permission: 'create-companies' }) : '',customClass: 'tooltip-dark' }"
                               style="display: inline-block">
                            <b-button :variant="'primary'" @click="add" :class="['ml-auto',{ 'cursor-not-allowed': !user_permissions.includes('create-companies') }]"
                                      :disabled="!user_permissions.includes('create-companies')">
                              <font-awesome-icon :icon="'plus'" />
                              {{ $t('default.add')}}
                            </b-button>
                          </div>
                        </div>

                    </div>

                    <span class="text-muted font-weight-light">{{ $t('page.companies_desc') }}</span>

                </div>

                <hr>

                <!-- Page content -->
                <div class="px-3">


                    <v-wait for="companies">


                        <loading slot="waiting"/>


                        <b-row>
                            <b-col md="4" class="my-2 ml-auto">
                                <b-input-group>
                                    <b-form-input v-model="filter" :placeholder="$t('simple.type_to_search')" />
                                    <b-input-group-append>
                                      <b-btn :disabled="!filter" @click="filter = ''">{{ $t('simple.clear') }}</b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>

                        <b-table stacked="md" responsive bordered striped hover :items="companies" :fields="company_fields" :filter="filter" class="vh-25">


                            <!-- Actions -->
                            <template slot="cell(actions)" slot-scope="cell">

                              <b-dropdown right v-if="cell.item.id != 1" :text="$t('simple.actions')" size="sm">

                                <b-dropdown-item @click="edit(cell.item.id)"  :class="!user_permissions.includes('update-companies') ? 'cursor-not-allowed' : ''"
                                                 v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-companies') ? $t('permission.permission_denied', { permission: 'update-companies' }) : '', customClass: 'tooltip-dark' }"
                                                 :disabled="!user_permissions.includes('update-companies')">{{ $t('simple.edit') }}</b-dropdown-item>

                              </b-dropdown>

                            </template>
                          <template slot="cell(status)" slot-scope="cell">
                            <span :class="{'text-success': cell.item.status == 1, 'text-danger': cell.item.status == 0}">
                              {{ cell.item.status == 1 ? $t('simple.enabled') : $t('simple.disabled') }}
                            </span>
                          </template>
                          <!-- Created at -->
                            <template slot="cell(deactivate_at)" slot-scope="cell">

                            {{cell.item.deactivate_at ? $moment($moment.utc(cell.item.deactivate_at)).local().format('YYYY-MM-DD HH:mm:ss'): '-' }}

                            </template>
                            <!-- Created at -->
                            <template slot="cell(created_at)" slot-scope="cell">

                                 {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm:ss') }}
                                 
                            </template>

                            <!-- Updated at -->
                            <template slot="cell(updated_at)" slot-scope="cell">

                                 {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm:ss') }}

                            </template>

                        </b-table>


                    </v-wait>

                </div>
                    

            </div>
            <div class="alert alert-danger text-center mt-5" style="max-width: 50%; margin: 0 auto;" v-if="permissionsReady && !user_permissions.includes('read-companies')">
              {{ $t('permission.permission_denied',{ permission: 'read-companies'}) }}
            </div>

        </div>

    </div>

</template>


<script>

    import CompanyAdd from './Modal/CompanyAdd.vue'
    import CompanyEdit from './Modal/CompanyEdit.vue'
    import CompanyDelete from './Modal/CompanyDelete.vue'

    import { create } from 'vue-modal-dialogs'
    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Companies component mounted.')
        },

        destroyed() {
            // Component destroyed
            console.log('Companies component destroyed.');
        },

        created: function() {
            // Component created
           this.getCompanies();
        },
        

        data: function() {
            return  {
                companies_api: '/api/v1/settings/companies/',
                companies: [],
                company_fields: [
                    { key: 'name', label: this.$t('simple.name'), sortable: true  },
                    { key: 'status', label: this.$t('simple.status'), sortable: true  },
                    { key: 'status_reason', label: this.$t('simple.company_status_reason'), sortable: true  },
                    { key: 'deactivate_at', label: this.$t('simple.deactivate_at'), sortable: true  },
                    { key: 'created_at', label: this.$t('simple.created'), sortable: true  },
                    { key: 'updated_at', label: this.$t('simple.updated'), sortable: true },
                    { key: 'actions', label: this.$t('simple.actions') },
                ],
                filter: null,
            }
        },
        
        metaInfo: function() {

            return {
                title: this.$t('page.companies'),
            }
            
        },

        methods: {

            getCompanies: async function() {

                // Start waiting
                this.$wait.start('companies');

                // Send request
                await axios.get(this.companies_api)

                  .then((response) => {
                    
                    // response data
                    this.companies = response.data;
                    //console.log(response);
                    // End waiting
                    this.$wait.end('companies');

                  })

                  .catch((error) => {
                    // Show error
                      Vue.toasted.error(this.$t('simple.error_info'));
                    // Log to console
                    //console.log(error);

                    // End waiting
                    this.$wait.end('companies');

                  });

            },


            add: async function() {
                // Show company add modal
                const company_add = create(CompanyAdd);

                if (await company_add() ){
                    // Refresh account list
                    this.getCompanies();
                }

            },

            edit: async function(id) {
                // Show company edit modal
                const company_edit = create(CompanyEdit, 'id');

                if (await company_edit(id) ){
                    // Refresh company list
                    this.getCompanies();
                }

            },

            
            remove: async function(id) {
                
                // Show company delete modal
                const company_delete = create(CompanyDelete, 'id');

                if (await company_delete(id) ){
                    // Refresh company list
                    this.getCompanies();
                }

            },

        },
      computed: {

        // Map getters
        ...mapGetters({
          user_permissions: 'User/getUserPermissions',

        }),
        permissionsReady() {
          return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
        }
      },
        
    }
</script>